import React, { useEffect, useState } from 'react'
import FormRender from '../../components/FormRender'
import useAxiosInstance from '../../hooks/useAxios'
import JsonView from '@uiw/react-json-view'

const NewsletterConfigFromExcel = () => {

    const [formData, setFormData] = useState({})
    const [isSaving, setIsSaving] = useState(false)
    const axiosInstance = useAxiosInstance()
    const [response, setResponse] = useState({})
    const [loading,setIsLoading] = useState(false)
    const [allNewsletterTypes,setAllNewsletterTypes] = useState([])

    useEffect(()=>{
        setIsLoading(true);
        axiosInstance.get(`/newsletter/v2/all_newsletters_type/`).then((res) => {
            setAllNewsletterTypes(res.data.data.map(it=>({label:it.name,value:it.name})));
            setIsLoading(false);
        });
    },[])
    return (
        <div>
            <div className="mr-4  p-3 my-5 border rounded-lg bg-white">
                <p className="text-2xl text-black font-medium mb-4">Newsletter Config From Excel Maker</p>
                {loading ? <p>Loading...</p>:
                <div className="rounded-xl bg-gray-100 p-3">
                    <FormRender
                        formData={formData}
                        formSettings={[
                            {
                                label: "Title",
                                type: "text",
                                saveKey: "title"
                            },
                            {
                                label: "Newsletter Type",
                                type: "select",
                                saveKey: "newsletter_type",
                                options: allNewsletterTypes
                            },
                            {
                                label: "Excel File",
                                type: "file",
                                saveKey: "excel_file"
                            },
                        ]}
                        setFormData={setFormData}
                    />

                    <button
                        disabled={isSaving}
                        className='bg-black px-3 mt-4 py-2 rounded text-sm font-sm disabled:bg-[#b6b6b6] disabled:text-black text-white'
                        onClick={() => {
                            setIsSaving(true)
                            const _formData = new FormData();
                            _formData.append('excel_file', formData.excel_file);
                            _formData.append('newsletter_type', formData.newsletter_type);
                            _formData.append('title', formData.title);

                            axiosInstance.post('/newsletter/v2/create_config_via_excel/', _formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            }).then(res => {
                                setIsSaving(false)
                                setResponse(res.data)
                            }).catch(err => {
                                console.log(err)
                            })
                        }
                        }
                    >{isSaving ? 'generating....' : 'Generate'}</button>

                    {Object.keys(response).length!==0 && <div className='mt-4'>
                    <JsonView
                        shortenTextAfterLength={0}
                        value={response}
                        displayObjectSize={false}
                        displayDataTypes={false}
                    />
                    </div>}
                </div>}
            </div>
        </div>
    )
}

export default NewsletterConfigFromExcel